module.exports = __webpack_public_path__ + "img/Capsicum_annuum.e4d250c1.jpg";